import { useCallback, useMemo, useState } from 'react';

import { Button } from '@/components/Button';
import { Divider } from '@/components/Divider';
import { Dropdown } from '@/components/Dropdown';
import { Input } from '@/components/Form/Input/Input';
import { Paragraph } from '@/components/Paragraph';

import { StyledBookingFormWrapper, StyledBookingItem, StyledBookingLabelAndPrice } from './styles';

export interface ExcursionBookingData {
  preferedDate: string | null;
  sumAdults: number;
  sumChildren: number;
}

interface ExcursionBookingFormProps {
  isOpened: boolean;
  onBooking: (bookingData: ExcursionBookingData) => void;
}

export function ExcursionBookingForm({ isOpened, onBooking }: ExcursionBookingFormProps) {
  const [preferedDate, setPreferedDate] = useState<string | null>(null);
  const [sumAdults, setSumAdults] = useState<number>(1);
  const [sumChildren, setSumChildren] = useState<number>(0);

  const adultOptions = useMemo(
    () => Array.from({ length: 10 }, (_, index) => ({ key: index.toString(), label: index.toString(), value: index })),
    [],
  );

  const childrenOptions = useMemo(
    () => Array.from({ length: 5 }, (_, index) => ({ key: index.toString(), label: index.toString(), value: index })),
    [],
  );

  const bookProduct = useCallback(() => {
    onBooking({ preferedDate, sumAdults, sumChildren });
  }, [onBooking, preferedDate, sumAdults, sumChildren]);

  return (
    <StyledBookingFormWrapper $opened={isOpened}>
      <Divider mt={4} mb={4} />
      <StyledBookingItem>
        <Paragraph weight={700}>Preferred Day</Paragraph>
        <Input
          type="date"
          onValueChange={(value) => {
            setPreferedDate(value);
          }}
        />
      </StyledBookingItem>
      <StyledBookingItem>
        <StyledBookingLabelAndPrice>
          <Paragraph weight={700}>Adults (18+ yrs)</Paragraph>
          <Paragraph weight={400}>€??,?? p.p.</Paragraph>
        </StyledBookingLabelAndPrice>
        <Dropdown
          placeholder={sumAdults.toString()}
          options={adultOptions}
          onOptionSelect={(e) => {
            setSumAdults(e.value);
          }}
        />
      </StyledBookingItem>

      <StyledBookingItem>
        <StyledBookingLabelAndPrice>
          <Paragraph weight={700}>Children (0-18 yrs)</Paragraph>
          <Paragraph weight={400}>€??,?? p.p.</Paragraph>
        </StyledBookingLabelAndPrice>
        <Dropdown
          placeholder={sumChildren.toString()}
          options={childrenOptions}
          onOptionSelect={(e) => {
            setSumChildren(e.value);
          }}
        />
      </StyledBookingItem>

      <StyledBookingItem>
        <Button variant="secondary" onClick={bookProduct} type="submit">
          Select + <strong>€??</strong>
        </Button>
      </StyledBookingItem>
    </StyledBookingFormWrapper>
  );
}
